import React, { useEffect, useState } from "react";
import { Accordion } from "react-bootstrap";
import "./detail-view-accordion.scss";
import { ReactSVG } from "react-svg";
import { Bold } from "lucide-react";
import { BoldText, LightText, PrimaryBoldText, PrimarySmallBoldText, SmallBoldText, SmallLightText, SmallNormalText } from "../../../../../utils/typographyUtils";

export const DetailViewAccordion = ({
  objectiveDetails,
  closeAllAccordions,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  useEffect(() => {
    if (closeAllAccordions) {
      setIsExpanded(false);
    }
  }, [closeAllAccordions]);
  const renderHeadingSubHeadingAndContent = (heading, subHeading, content) => {
    return (
      <div className="pt-2 pb-3">
        <SmallBoldText classNames={"d-block"}>
          {heading} <LightText>{subHeading}</LightText>
        </SmallBoldText>
        {subHeading ? (
          <SmallNormalText classNames={"d-block mb-2"}>
            {subHeading}
          </SmallNormalText>
        ) : null}
        <SmallNormalText classNames={"d-block"}>{content}</SmallNormalText>
      </div>
    );
  };
  const renderLabelAndData = (
    label,
    data,
    noMargin = false,
    noWidthBased = false,
  ) => {
    if (noWidthBased) {
      return (
        <div className={`d-flex ${noMargin ? "" : "my-1"}`}>
          <SmallLightText classNames={"me-3"}>{label}</SmallLightText>
          <SmallNormalText>{data}</SmallNormalText>
        </div>
      );
    }
    return (
      <div className={`d-flex ${noMargin ? "" : "my-1"} w-50`}>
        <SmallLightText classNames={"w-25"}>{label}</SmallLightText>
        <SmallNormalText>{data}</SmallNormalText>
      </div>
    );
  };
  return (
    <div id="detail-view-accordion">
      <div className="recommendation-context-accordion">
        <div
          onClick={() => setIsExpanded(!isExpanded)}
          className="recommendation-context-accordion-header border-bottom d-flex align-items-start cursor-pointer  justify-content-between p-3"
        >
          <div className="d-flex align-items-top">
            <img
              src="/assets/images/recommendation_context.svg"
              className="mb-1 me-2"
              height={21}
              width={21}
            />
            <div>
              <PrimarySmallBoldText classNames={"d-block"}>
                X-Ray Recommendation
              </PrimarySmallBoldText>
              {/* <SmallLightText>
                This section gives you background about the practice and
                recommendation to improve it as per X-Ray report.
              </SmallLightText> */}
            </div>
          </div>
          <img
            onClick={(e) => {}}
            className="cursor-pointer"
            src={`/assets/images/${isExpanded ? "up-arrow.svg" : "down-arrow.svg"}`}
          />
        </div>
        <div
          className={`recommendation-context-accordion-body ${isExpanded ? "open px-3 m-3 cs-br-8 border mb-0" : ""}`}
        >
          <div className="pe-3 pt-3 pb-2">
            {objectiveDetails.disciplineName &&
              renderLabelAndData(
                "Discipline",
                objectiveDetails.disciplineName ?? "-",
                true,
                true,
              )}
            {/* {objectiveDetails.subDisciplineName &&
              renderLabelAndData(
                "Sub Discipline",
                objectiveDetails.subDisciplineName ?? "-",
              )}
            {objectiveDetails.subSubDisciplineName &&
              renderLabelAndData(
                "Sub Sub Discipline",
                objectiveDetails.subSubDisciplineName ?? "-",
              )} */}
            {/* {objectiveDetails.rank &&
              renderLabelAndData("Rank", objectiveDetails.rank ?? "-")} */}
          </div>
          <div className="bg-light-new px-3 py-2 d-flex justify-content-between align-items-center">
            <div className="bg-white rounded d-flex px-2 py-1 align-items-center">
              <SmallLightText classNames={"font-weight-bold"}>
                Level
              </SmallLightText>
              <span className="vertical-separator-stretched mx-3"></span>
              <SmallNormalText>
                Current{" "}
                <PrimaryBoldText>
                  {objectiveDetails?.current_level}
                </PrimaryBoldText>
              </SmallNormalText>
              <ReactSVG
                src="/assets/images/right_arrow_small.svg"
                className="mx-3"
              />
              <SmallNormalText>
                Next{" "}
                <PrimaryBoldText>
                  {objectiveDetails?.next_level}
                </PrimaryBoldText>
              </SmallNormalText>
            </div>
            <div className="bg-white rounded px-2 py-1">
              <img src="/assets/images/star.svg" className="me-2" />
              <SmallLightText classNames={"me-3"}>Highest Level</SmallLightText>
              <PrimaryBoldText>
                {objectiveDetails?.highest_level}
              </PrimaryBoldText>
            </div>
          </div>
          <div>
            {renderHeadingSubHeadingAndContent(
              <BoldText>
                Recommendation:{" "}
                <span className="light-text font-weight-normal">
                  Below is the recommendation to help you move to the next level
                  and improve the practice{" "}
                </span>
              </BoldText>,
              undefined,
              objectiveDetails?.recommendation,
            )}
            {objectiveDetails?.coachNote &&
              renderHeadingSubHeadingAndContent(
                "Coach Note",
                null,
                objectiveDetails?.coachNote,
              )}
          </div>
        </div>
      </div>
    </div>
  );
};
